import React, { useEffect, useState } from "react";
import LoadingCom from "../LoadingCom";
import { Col, Row } from "antd";
import { useNavigate } from "react-router-dom";
import AwsAxios from "../../utils/AwsAxios";

const SubmittedIdeas = () => {
  const [submittedIdeas, setSubmittedIdeas] = useState();
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const email = localStorage.getItem("username");
  let [Imageloading, setImageLoading] = useState([]);

  const fetchImageApi = async (image) => {
    try {
      const parts = image?.split("/resources/");
      const imageId = parts[1];
      console.log(imageId, "Response fetch imagessss");
      const response = await AwsAxios.get(
        `https://7q63conwve.execute-api.us-east-2.amazonaws.com/Prod/hype/image/${imageId}`
      );

      console.log(response.data, "Response fetch imagessss");
      return `data:image/jpeg;base64,${response.data}`;
    } catch (error) {
      console.error("Error fetching image:", error);
      return null;
    }
  };

  useEffect(() => {
    setLoading(true);
    setLoading(true);
    const fetchData = async () => {
      setLoading(true);
      setImageLoading(true);
      try {
        const response = await AwsAxios.get(
          `https://7q63conwve.execute-api.us-east-2.amazonaws.com/Prod/hype/ideas/${email}`
        );
        const items = response?.data?.data?.items || [];
        setSubmittedIdeas(items);

        console.log("Helloooooooooooooooooooooooo", response);
        setLoading(false);

        // Fetch images and transform data
        const transformedItems = await Promise.all(
          items.map(async (item) => {
            if (item.properties[5].type === "VALUES") {
              const image = await fetchImageApi(
                item.properties[5]?.values[0]?.image
              );
              item.properties[5].values[0].image = image;
            }
            return item;
          })
        );
        if (transformedItems.length > 0) {
          setSubmittedIdeas(transformedItems);
          setImageLoading(false);
        }

        console.log({ transformedItems });
      } catch (error) {
        console.error("Error fetching submitted ideas:", error);
        setImageLoading(false);
        setLoading(false);
      }
    };

    fetchData();
  }, [email]);

  console.log({ submittedIdeas });
  return (
    <Row gutter={[10, 10]}>
      {loading ? (
        <div className="w-full">
          <LoadingCom />
        </div>
      ) : submittedIdeas && submittedIdeas.length > 0 ? (
        submittedIdeas.map((project) => (
          <Col
            md={12}
            key={project.id}
            className="cursor-pointer"
            onClick={() =>
              navigate(`/submitted-ideas/${project.id}`, {
                state: { data: project },
              })
            }
          >
            <div className="bg-pureWhite rounded-xl shadow-signupBoxShadow p-3 h-full">
              {Imageloading ? (
                <LoadingCom />
              ) : (
                <img
                  className="rounded-lg h-[200px] w-full shadow-profileShadow"
                  src={project?.properties[5]?.values[0]?.image}
                  alt={project?.id}
                />
              )}
              <div className="flex justify-between items-center mt-2">
                <p className="text-base text-DarkGrey font-semibold w-[80%]">
                  {project?.properties[1]?.value}
                </p>
              </div>
              <div className="flex mt-2 justify-between items-center">
                <p className="text-sm text-DarkGrey">
                  Problem Description: <br />
                  <span className="font-medium">
                    {project?.properties[2]?.value || "Not Available"}
                  </span>
                </p>
              </div>
              <div className="flex justify-between">
                <p className="text-[10px] mt-2 text-gray-400">
                  Idea Description: <br />
                  <div
                    className="font-bold text-[10px]"
                    dangerouslySetInnerHTML={{
                      __html: project?.properties[3]?.value,
                    }}
                  />
                </p>
                <p className="flex items-center gap-x-2 text-[10px] text-gray-400">
                  <span>Status:</span>
                  <span className="font-bold">
                    {project?.properties[4]?.values[0]?.value}
                  </span>
                </p>
              </div>
              <div className="flex flex-col mt-2">
                <p className="gap-x-2 text-[10px] text-gray-400">
                  Email: {project?.properties[7]?.value}
                </p>
                <p className="gap-x-2 text-[10px] text-gray-400">
                  <span>Campaign Description</span>
                </p>
                <p
                  dangerouslySetInnerHTML={{
                    __html: project?.properties[6]?.value,
                  }}
                  className="gap-x-2 text-[10px] text-gray-400"
                />
              </div>
            </div>
          </Col>
        ))
      ) : (
        <div className="w-full text-center text-gray-500">
          No enrolled courses available
        </div>
      )}
    </Row>
  );
};

export default SubmittedIdeas;
